class LoadingParameters {
	constructor({
					title, 
					text,
					events = {
						onShowModal: (e) => {},
						onShownModal: (e) => {},
						onHideModal: (e) => {},
						onHiddenModal: (e) => {},
						onHidePreventedModal: (e) => {}
					}
				}) {
		this.title = title;
		this.text = text;
		this.events = events;
	}

	title;
	text;
	events;
}

class LoadingClass {

	constructor() {
		if (window.LoadingInstance) {
			return window.LoadingInstance;
		}
		window.LoadingInstance = this;
		$("document").ready(() => this.#init());
	}
	#init(){
		
	}
	#loadingModal = null;
	//
	// /**
	//  * 
	//  * @param parameters : LoadingParameters
	//  */
	// show(parameters) {
	//
	// 	let {title, text, events} = parameters;
	//
	// 	if (!this.#loadingModal) {
	// 		let loadingModal = $(
	// 			'<div class="modal fade" id="pnlModalStaticLoadingBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="lblStaticLoadingBackdrop" aria-hidden="true">' +
	// 			'<div class="modal-dialog">' +
	// 			'<div class="modal-content">' +
	// 			'<div class="modal-header">' +
	// 			`<h5 class="modal-title" id="lblStaticLoadingBackdrop">${title}</h5>` +
	// 			'</div>' +
	// 			'<div class="modal-body">' +
	// 			`${text}` +
	// 			'</div>' +
	// 			'</div>' +
	// 			'</div>' +
	// 			'</div>');
	//
	// 		if(events){
	// 			loadingModal
	// 				.on('show.bs.modal', events.onShowModal)
	// 				.on('shown.bs.modal', events.onShownModal)
	// 				.on('hide.bs.modal', events.onHideModal)
	// 				.on('hidden.bs.modal', events.onHiddenModal)
	// 				.on('hidePrevented.bs.modal', events.onHidePreventedModal);				
	// 		}
	//		
	// 		$("body").append(loadingModal);
	// 		this.#loadingModal = loadingModal;
	// 	}
	//
	// 	this.#loadingModal.modal('show')
	// };
//
	async showDefaultLoading(){
		return await this.show(new LoadingParameters({title: 'Consulta em andamento', text: 'Aguarde. Carregando...'}));
	}
	/*
	 * 
	 * @param parameters : LoadingParameters?
	 * @returns {Promise<void>}
	 */
	show(parameters) {

		if(!parameters){
			parameters = {title: 'Carregando...', text: 'Aguarde. Carregando o conteúdo da página.'};
		}
		
		let {title, text, events} = parameters;

		return new Promise((resolve, reject)=>{
			if (!this.#loadingModal) {
				let loadingModal = $(
					'<div class="modal fade" id="pnlModalStaticLoadingBackdrop" data-backdrop="static"  tabindex="-1" aria-labelledby="lblStaticLoadingBackdrop" aria-hidden="true">' +
					'<div class="modal-dialog">' +
					'<div class="modal-content">' +
					'<div class="modal-header">' +
					`<h5 class="modal-title" id="lblStaticLoadingBackdrop">${title}</h5>` +
					'</div>' +
					'<div class="modal-body">' +
					`${text}` +
					'</div>' +
					'</div>' +
					'</div>' +
					'</div>');

				loadingModal.on('shown.bs.modal',()=>resolve());
				
				if(events){
					loadingModal
						.on('show.bs.modal', events.onShowModal)
						.on('hide.bs.modal', events.onHideModal)
						.on('hidden.bs.modal', events.onHiddenModal)
						.on('hidePrevented.bs.modal', events.onHidePreventedModal);
				}

				$("body").append(loadingModal);
				this.#loadingModal = loadingModal;
			}
			else{
				this.#loadingModal.off('shown.bs.modal').on('shown.bs.modal',()=>resolve());	
			}
			this.#loadingModal.modal('show');	
		})
		
		
	};
	hide(){
		if (this.#loadingModal) {
			this.#loadingModal.modal('hide');
		}
	}
}

export {LoadingParameters}

export const Loading= new LoadingClass();
